import { createSlice } from "@reduxjs/toolkit";
import { signInUser } from "../Components/Utility/Auth";

const auth = signInUser();

const initiState = {
  name: "",
  email: "",
  code: "",
  aamarId: auth?.aamarId || undefined,
  company: "",
  products: [],
  address: "",
  type: "",
  phone: "",
  status: "",
}
export const supplierSlice = createSlice({
  name: "supplier",
  initialState: initiState,
  reducers: {
    supplierProducts: (state, action) => {
      state.products = action.payload;
    },
    updateFieldValue: (state, action) => {
      console.log("action.payload", action.payload)
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      }
    },
    DataAddSuppliers: (state, action) => {
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.code = action.payload.code;
      state.company = action.payload.company;
      state.address = action.payload.address;
      state.type = action.payload.type;
      state.phone = action.payload.phone;
      state.aamarId = action.payload.aamarId;
      state.products = action.payload.products;
      state.status = action.payload.status;
    },
    resetSupplierSlice: (state) => {
      return initiState;  // Make sure to return the initial state
    }
  },
});

export const { supplierProducts, DataAddSuppliers, updateFieldValue, resetSupplierSlice } = supplierSlice.actions;
export const supplierReducer = supplierSlice.reducer;
